import { render } from "./GetImageCapturedData.vue?vue&type=template&id=6e32b42e&scoped=true"
import script from "./GetImageCapturedData.vue?vue&type=script&lang=js"
export * from "./GetImageCapturedData.vue?vue&type=script&lang=js"

import "./GetImageCapturedData.vue?vue&type=style&index=0&id=6e32b42e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e32b42e"]])

export default __exports__